import { keyframes, styled } from "goober";
import { Link } from "./Link";
import { ClickButton } from "./ClickButton";
import { PressButton } from "./PressButton";

export const mapChromeSlideUp = keyframes`
  0% {
    transform: translateY(calc(100% + 12px));
    opacity: 0;
  }
  60% {
    transform: translateY(-2px);
    opacity: 1;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const MapChromeCorner = styled("div")`
  position: absolute;
  bottom: 12px;
  z-index: 3;
  display: flex;
  align-items: center;
  pointer-events: none;

  &[data-side="left"] {
    left: 12px;
  }
  &[data-side="right"] {
    right: 12px;
  }
`;

export const MapChromePill = styled("div")`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 0 4px;
  border-radius: 9999px;
  background: var(--surface-primary);
  outline: 0.5px solid var(--border-alpha);
  box-shadow: var(--elevation-low);
  box-sizing: border-box;
  opacity: 0;
  transform: translateY(calc(100% + 12px));
  pointer-events: none;
  transition:
    opacity 160ms ease,
    transform 160ms ease;

  &[data-visible="true"] {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
    animation: ${mapChromeSlideUp} 300ms cubic-bezier(0.22, 0.68, 0.35, 1.05);
  }
  &:focus-within {
    opacity: 1;
    transform: translateY(0);
    pointer-events: auto;
  }

  @media (hover: none) {
    &[data-touch-persistent="true"] {
      opacity: 1;
      transform: translateY(0);
      pointer-events: auto;
      animation: none;
    }
  }
`;

const controlStyles = `
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 9999px;
  color: var(--text-primary);
  text-decoration: none;

  &:hover {
    background: var(--alpha4);
  }
  &:active {
    background: var(--alpha8);
  }
  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: 2px solid var(--control-bg);
    outline-offset: 2px;
  }
`;

export const MapChromePressButton = styled(PressButton)`
  ${controlStyles}
`;

export const MapChromeClickButton = styled(ClickButton)`
  ${controlStyles}
`;

export const MapChromeLink = styled(Link)`
  ${controlStyles}
`;
